import type { DatasetAudioRecording } from '@api';
import { createContext, useContext } from 'react';

export type ResolveAudioByFileName = (fileName: string) => Promise<DatasetAudioRecording | null>;
export const AudioRecordingsContext = createContext<ResolveAudioByFileName | null>(null);
export const useResolveAudioRecording = () => useContext(AudioRecordingsContext);
